/**
 * Builds a redirect URI using the canonical www. host.
 *   sleepiodev.com        → www.sleepiodev.com
 *   login.sleepiodev.com  → www.sleepiodev.com
 *   www.sleepiodev.com    → www.sleepiodev.com (unchanged)
 *   localhost             → localhost (unchanged — local dev safe)
 */
export function buildCanonicalRedirectUri() {
  const { protocol, hostname, pathname } = window.location;
  if (!hostname.includes('.') || hostname.startsWith('www.')) {
    return `${protocol}//${hostname}${pathname}`;
  }
  const parts = hostname.split('.');
  const canonicalHost = ['www', ...parts.slice(parts.length > 2 ? 1 : 0)].join(
    '.'
  );
  return `${protocol}//${canonicalHost}${pathname}`;
}
